import { render } from "./status-lane.vue?vue&type=template&id=fc3d98b6&scoped=true"
import script from "./status-lane.vue?vue&type=script&lang=js"
export * from "./status-lane.vue?vue&type=script&lang=js"

import "./status-lane.vue?vue&type=style&index=0&id=fc3d98b6&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\BijouCRM\\src\\ui\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc3d98b6"]])

export default __exports__